export default {
  setInvents(state, value) {
    state.invents = value
  },
  updateInvents(state, value) {
    state.invents = state.invents.concat(value)
  },
  prependInvents(state, value) {
    state.invents.unshift(value)
  },
  setInvent(state, value) {
    state.invent = value
  },
  setInventField(state, obj) {
    if (state.invent) {
      state.invent = { ...state.invent, ...obj }
    }
  },
  changeInvent(state, obj) {
    for (let i = 0; i < state.invents.length; i++) {
      if (state.invents[i].id === obj.id) {
        const item = _.cloneDeep(obj)
        state.invents.splice(i, 1, item)
        break
      }
    }
  },
  deleteInvent(state, id) {
    for (let i = 0; i < state.invents.length; i++) {
      if (state.invents[i].id === id) {
        state.invents.splice(i, 1)
        break
      }
    }
  },
  addInventItem(state, obj) {
    if (state.invent.items) {
      for (let i = 0; i < state.invent.items.length; i++) {
        if (state.invent.items[i].id === obj.id) {
          const item = _.cloneDeep(obj)
          state.invent.items.splice(i, 1, item)
          return
        }
      }

      state.invent.items.unshift(obj)
    }
  },
  changeInventItem(state, obj) {
    if (state.invent.items) {
      for (let i = 0; i < state.invent.items.length; i++) {
        if (state.invent.items[i].id === obj.id) {
          const item = _.cloneDeep(obj)
          state.invent.items.splice(i, 1, item)
          break
        }
      }
    }
  },
  deleteInventItem(state, id) {
    if (state.invent.items) {
      for (let i = 0; i < state.invent.items.length; i++) {
        if (state.invent.items[i].id === id) {
          state.invent.items.splice(i, 1)
          break
        }
      }
    }
  },
  setInventFilters(state, payload) {
    state.inventFilters = payload
  },
  setInventStatuses(state, value) {
    state.inventStatuses = value
  },
}
